import useStorefrontModeContext from '@src/quince-site-common/src/contexts/storefront-mode-context'

import { VariantPurchaseInfo } from '../productForm/ProductForm'

import getPreorder from './getPreorder'
import { CTA_TYPE } from './productCTAConstants'

interface ProductCTAType {
  selectedVariantPurchaseInfo?: VariantPurchaseInfo
}

function useProductCTAType({ selectedVariantPurchaseInfo }: ProductCTAType) {
  const isPreorder = selectedVariantPurchaseInfo?.isPreorder
  const { showPreorder } = getPreorder(isPreorder)
  const preOrderShippingDate = selectedVariantPurchaseInfo?.preOrderShippingDate
  const { isB2BMode } = useStorefrontModeContext()

  if (isB2BMode) {
    if (selectedVariantPurchaseInfo?.selectedVariantId && selectedVariantPurchaseInfo.availableInventory <= 0) {
      return CTA_TYPE.OUT_OF_STOCK
    }

    return CTA_TYPE.ADD_TO_CART
  }

  if (selectedVariantPurchaseInfo?.showWaitList) {
    return CTA_TYPE.WAITLIST
  }

  if (isPreorder) {
    const isFuturePreOrderShippingDate = preOrderShippingDate ? Date.parse(preOrderShippingDate) >= Date.now() : false

    if (showPreorder && isFuturePreOrderShippingDate) {
      return CTA_TYPE.PREORDER
    }
    return CTA_TYPE.WAITLIST
  }

  return CTA_TYPE.ADD_TO_CART
}

export default useProductCTAType
